import styled from 'styled-components';
import { Select } from '@mui/material';
import { Styling, Colors } from '../../../../constants';

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const PageStatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${Styling.DEFAULT_SPACING_HALVED}px 0;
`;

export const PageSizeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: ${Colors.BLACK_50};
`;

export const PageSizeSelect = styled(Select)`
  height: 28px;
  font-size: 13px;
  .MuiSelect-select {
    padding: 4px 8px;
  }
`;
